import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/Warranty/index.js'), 'Warranty/index.js')
  resolveStoreModules(require('../store/Voucher/index.js'), 'Voucher/index.js')
  resolveStoreModules(require('../store/User/index.js'), 'User/index.js')
  resolveStoreModules(require('../store/Sidebar/index.js'), 'Sidebar/index.js')
  resolveStoreModules(require('../store/Review/index.js'), 'Review/index.js')
  resolveStoreModules(require('../store/Region/index.js'), 'Region/index.js')
  resolveStoreModules(require('../store/Product/index.js'), 'Product/index.js')
  resolveStoreModules(require('../store/Partner/index.js'), 'Partner/index.js')
  resolveStoreModules(require('../store/Order/index.js'), 'Order/index.js')
  resolveStoreModules(require('../store/Linktree/index.js'), 'Linktree/index.js')
  resolveStoreModules(require('../store/GoogleMaps/index.js'), 'GoogleMaps/index.js')
  resolveStoreModules(require('../store/Flashsale/index.js'), 'Flashsale/index.js')
  resolveStoreModules(require('../store/Files/index.js'), 'Files/index.js')
  resolveStoreModules(require('../store/Feature/index.js'), 'Feature/index.js')
  resolveStoreModules(require('../store/EventSale/index.js'), 'EventSale/index.js')
  resolveStoreModules(require('../store/Contents/index.js'), 'Contents/index.js')
  resolveStoreModules(require('../store/Checkout/index.js'), 'Checkout/index.js')
  resolveStoreModules(require('../store/Category/index.js'), 'Category/index.js')
  resolveStoreModules(require('../store/Cart/index.js'), 'Cart/index.js')
  resolveStoreModules(require('../store/Brand/index.js'), 'Brand/index.js')
  resolveStoreModules(require('../store/Base/index.js'), 'Base/index.js')
  resolveStoreModules(require('../store/BankAccount/index.js'), 'BankAccount/index.js')
  resolveStoreModules(require('../store/Auth/index.js'), 'Auth/index.js')
  resolveStoreModules(require('../store/Affiliate/index.js'), 'Affiliate/index.js')
  resolveStoreModules(require('../store/Account/index.js'), 'Account/index.js')
  resolveStoreModules(require('../store/Category/AllCategoryDrawer.js'), 'Category/AllCategoryDrawer.js')
  resolveStoreModules(require('../store/Checkout/branch.js'), 'Checkout/branch.js')
  resolveStoreModules(require('../store/Partner/CatalogPartners.js'), 'Partner/CatalogPartners.js')
  resolveStoreModules(require('../store/Partner/PartnerProfile.js'), 'Partner/PartnerProfile.js')
  resolveStoreModules(require('../store/Product/filter.js'), 'Product/filter.js')
  resolveStoreModules(require('../store/Product/ProductDetailPage.js'), 'Product/ProductDetailPage.js')
  resolveStoreModules(require('../store/Product/ProductsFilterMobile.js'), 'Product/ProductsFilterMobile.js')
  resolveStoreModules(require('../store/Product/ProductsSearchResult.js'), 'Product/ProductsSearchResult.js')
  resolveStoreModules(require('../store/User/address.js'), 'User/address.js')
  resolveStoreModules(require('../store/User/order.js'), 'User/order.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
